'use client'
import { GetLanguageMenuSettingsDto } from '@/shared/api/strapi/requests'
import { ModalBlockDto } from '@/shared/api/strapi/requests/getModalsBlock'
import { Input } from '@/shared/ui/input'
import { Button } from '@/shared/ui/button'
import { Link } from '@/shared/i18n'
import { WhatsappHeaderWhiteIcon } from '@/shared/icons'
import PhoneInput from 'react-phone-input-2'
import { cn } from '@/shared/lib'
import { useRef, useState } from 'react'
import { toast } from 'sonner'
import { Loader2 } from 'lucide-react'
import { StrapiApi } from '@/shared/api'
import { isValidPhoneNumber } from 'libphonenumber-js'
import './phone-input.css'
// import 'react-phone-input-2/lib/plain.css'

export const ContactForm = ({
  settings,
  modalBlock,
}: {
  settings: GetLanguageMenuSettingsDto['dataSettings']
  modalBlock: ModalBlockDto
}) => {
  const formRef = useRef<HTMLFormElement>(null)
  const [nameValid, setNameValid] = useState(false)
  const [phoneValid, setPhoneValid] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  return (
    <form
      ref={formRef}
      onSubmit={e => {
        e.preventDefault()
        if (formRef.current) {
          const formData = new FormData(formRef.current)
          const data = Object.fromEntries(formData.entries())
          setIsLoading(true)
          StrapiApi.postForm(data)
            .then(() => toast(modalBlock.contact_me_success_response))
            .catch(() =>
              toast(modalBlock.contact_me_wrong_response, {
                style: {
                  color: 'white',
                  background: '#f87171',
                },
              }),
            )
            .finally(() => setIsLoading(false))
        }
      }}
      className={'flex flex-col gap-y-2'}
    >
      <p>{modalBlock.contact_me_text}</p>
      <Input
        className={'shadow-xs'}
        name={'name'}
        onChange={value => {
          setNameValid(value.target.value.length > 1)
        }}
        type={'text'}
        placeholder={modalBlock.form_name_placeholder}
      />
      <div className="w-full relative">
        <PhoneInput
          inputProps={{ name: 'phone' }}
          enableLongNumbers={false}
          onChange={(_value, data, _event, formattedValue) => {
            if ('countryCode' in data) {
              setPhoneValid(isValidPhoneNumber(formattedValue))
              return
            }
            setPhoneValid(false)
          }}
          inputClass={cn(
            'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
            'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
            'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
          )}
          searchClass={cn(
            'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
            'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
            'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
          )}
          // dropdownClass={
          //   'bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 max-h-(--radix-dropdown-menu-content-available-height) min-w-[8rem] origin-(--radix-dropdown-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border p-1 shadow-md'
          // }
          country={'ae'}
          placeholder={modalBlock.form_phone_placeholder}
          enableSearch={false}
          disableSearchIcon={true}
          searchPlaceholder="Filter countries"
        />
      </div>
      <Button
        variant={'default'}
        className={'py-6 w-full bg-[#717172] text-white hover:bg-[#888889]'}
        type={'submit'}
        disabled={isLoading || !(nameValid && phoneValid)}
      >
        {isLoading && <Loader2 className="animate-spin text-primary stroke-peach" />}
        {!isLoading && modalBlock.send_button_text}
      </Button>

      <Button variant={'secondary'} className={'py-6 w-full'} asChild>
        <Link href={settings.whatsapp}>
          {modalBlock.book_now_button_text}
          <WhatsappHeaderWhiteIcon className={'w-12 fill-current'} />
        </Link>
      </Button>
    </form>
  )
}
